/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import arrow from "designs/images/streaming/arrow_down.png";
import { useI18n } from "hooks/i18n/i18n";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { FC } from "react";

export const SelectVariationSelectBox: FC<{
  variationList: ProductData[];
  onChange: (productId: string) => void;
}> = ({ variationList, onChange }) => {
  const { t } = useI18n();

  return (
    <select
      css={css`
        width: 100%;
        padding: 8px 32px 8px 16px;
        font-size: 14px;
        font-weight: normal;
        background-color: #f4f4f4;
        background-image: url(${arrow});
        background-size: 8px auto;
        background-repeat: no-repeat;
        background-position-x: right 16px;
        background-position-y: center;
        border: 1px solid #dedede;
        border-radius: 5px;
        appearance: none;
        cursor: pointer;
      `}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value={""}>{t("streaming.commerceGoodsList.choose")}</option>
      {variationList.map((variation) => (
        <option key={variation._id} value={variation._id}>
          {variation.subClassName}
        </option>
      ))}
    </select>
  );
};
